import { useEffect, useState } from 'react';
import { Keyboard } from 'react-native';

export function useKeyboardWillShow() {
	const [keyboardWillShow, setKeyboardWillShow] = useState(false);

	useEffect(() => {
		const keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', () => {
			setKeyboardWillShow(true);
		});
		const keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', () => {
			setKeyboardWillShow(false);
		});

		return () => {
			keyboardWillShowListener.remove();
			keyboardWillHideListener.remove();
		};
	}, []);

	return keyboardWillShow;
}
